import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import {ElMessage} from "element-plus";

import Layout from '@/baseLayout/LayoutPage'
const adminRole = "admin"
const roleSpecial = "special"
const roleStudent = "students"
const adminGroupOne = "参赛管理"
const adminGroupTwo = "基础管理"
const adminGroupThree = "初赛评审"
const adminGroupFour = "复赛评审"
const adminGroupFive = "系统管理"
const routes = [
  {
    path: "/",
    redirect:()=>{
      const role = store.getters['loginModel/getRole']
      if(role==="admin"){
       return {path:"/admin",replace:true}
      }else if(role==="special"){
        return {path:"/special",replace:true}
      }else if(role==="students"){
        return {path:"/student",replace:true}
      }else{ // 没有角色
        return {path:"/login",replace:true}
      }
    },
  },

  {
    path: "/admin",
    name:"admin",
    component:Layout,
    redirect:"/admin/teamsList",
    children:[
      // 参赛管理 classicOne
      {
        path: 'teamsList',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/TeamsListView.vue'),
        meta:{title:"参赛队信息管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'numbers',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/NumbersView.vue'),
        meta:{title:"参赛队员管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'teachersView',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/TeachersView.vue'),
        meta:{title:"辅导老师管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'entry',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/EntryView.vue'),
        meta:{title:"参赛作品管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'entrydetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/EntryDetailView.vue'),
        meta:{title:"参赛作品详情",menuShow:false,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'downloadDocs',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/DownloadDocs.vue'),
        meta:{title:"参赛文件管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'downloadDocs',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/DownloadDocs.vue'),
        meta:{title:"参赛文件管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'repechageentrylist',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageEntryView.vue'),
        meta:{title:"复赛文件信息",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'repechageentrydetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageEntryDetailView.vue'),
        meta:{title:"复赛文件详情",menuShow:false,"group":adminGroupOne,'role':adminRole}
      },
// 专家管理
      {
        path: 'specialist',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/SpecialistView.vue'),
        meta:{title:"专家管理",menuShow:true,'role':adminRole}
      },
//    基础管理 adminGroupTwo
      {
        path: 'information',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/InformationView.vue'),
        meta:{title:"大赛信息管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
      {
        path: 'typemanagement',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/TypemanagementView.vue'),
        meta:{title:"选题类型管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
      {
        path: 'schools',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/SchoolsView.vue'),
        meta:{title:"学校信息管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
      {
        path: 'zone',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/zoneView.vue'),
        meta:{title:"大赛赛区管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
//    初赛评审 adminGroupThree
      {
        path: 'preliminarygroup',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminarygroupView.vue'),
        meta:{title:"初赛分组管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
      },
      {
        path: 'preliminarymark',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminarymarkView.vue'),
        meta:{title:"初赛打分标准",menuShow:true,"group":adminGroupThree,'role':adminRole}
      },
      {
        path: 'preliminaryResult',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminaryResultView.vue'),
        meta:{title:"初赛评分结果",menuShow:true,"group":adminGroupThree,'role':adminRole}
      },
      {
        path: 'sendMessage',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/SendMessage.vue'),
        meta:{title:"短信通知结果",menuShow:true,"group":adminGroupThree,'role':adminRole}
      },
      //复赛评分 adminGroupFour
      {
        path: 'repechagegroup',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechagegroupView.vue'),
        meta:{title:"复赛分组管理",menuShow:true,"group":adminGroupFour,'role':adminRole}
      },
      {
        path: 'repechagemark',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechagemarkView.vue'),
        meta:{title:"复赛打分标准",menuShow:true,"group":adminGroupFour,'role':adminRole}
      },
      {
        path: 'repechageResult',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageResultView.vue'),
        meta:{title:"复赛评分结果",menuShow:true,"group":adminGroupFour,'role':adminRole}
      },
      // 系统管理 adminGroupFive
      // {
      //   path: 'organization',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/admin/OrganizationView.vue'),
      //   meta:{title:"组织机构",menuShow:true,"group":adminGroupFive,'role':adminRole}
      // },
      {
        path: 'user',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/UserView.vue'),
        meta:{title:"用户管理",menuShow:true,"group":adminGroupFive,'role':adminRole}
      },
      {
        path: 'roles',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RolesView.vue'),
        meta:{title:"角色权限",menuShow:true,"group":adminGroupFive,'role':adminRole}
      },
      {
        path: 'logs',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/LogsView.vue'),
        meta:{title:"操作日志",menuShow:true,"group":adminGroupFive,'role':adminRole}
      },
      // {
      //   path: 'sysinfo',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/admin/SysinfoView.vue'),
      //   meta:{title:"系统信息",menuShow:true,"group":adminGroupFive,'role':adminRole}
      // },
    ]
  },
  {
    path: "/special",
    name:"special",
    component:Layout,
    redirect:"/special/specialinfo",
    children:[
      {
        path: 'specialinfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/SpecialinfoView.vue'),
        meta:{title:"专家信息",menuShow:true,'role':roleSpecial}
      },
      {
        path: 'firstscoring',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/ReviewFirstScoring.vue'),
        meta:{title:"初赛评审打分",menuShow:true,'role':roleSpecial}
      },
      {
        path: 'secondscoring',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/ReviewSecondScoring.vue'),
        meta:{title:"复赛评审打分",menuShow:true,'role':roleSpecial}
      },
      {
        path: 'entryscoring',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/EntryScoringView.vue'),
        meta:{title:"作品评分",menuShow:true,'role':roleSpecial}
      }
    ]
  },
  {
    path: "/student",
    name:"student",
    component:Layout,
    redirect:"/student/teams",
    children:[
      {
        path: 'teams',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/TeamsView.vue'),
        meta:{title:"参赛队信息管理",menuShow:true,role:roleStudent}
      },
      {
        path: 'addTeam',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/AddTeamView.vue'),
        meta:{title:"添加参赛队员",menuShow:true,role:roleStudent}
      },
      {
        path: 'addTeacher',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/AddTeacherView.vue'),
        meta:{title:"添加辅导老师",menuShow:true,role:roleStudent}
      },
      {
        path: 'downloadDocs',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/DownloadDocs.vue'),
        meta:{title:"参赛文件下载",menuShow:true,role:roleStudent}
      },
      {
        path: 'entry',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/EntryView.vue'),
        meta:{title:"提交参赛作品",menuShow:true,role:roleStudent}
      },
      {
        path: 'repechage',
        component: () =>import(/* webpackChunkName: "about" */ '../views/students/RepechageEntryView.vue'),
        meta:{title:"复赛文件上传",menuShow:true,role:roleStudent}
      },
      {
        path: 'awardcertificate',
        component: () =>import(/* webpackChunkName: "about" */ '../views/students/AwardCertificateView.vue'),
        meta:{title:"获奖证书查询",menuShow:true,role:roleStudent}
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component:() =>  import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue')
  },
  {
    path: '/:path(.*)',
    name: '404',
    meta: {},
    component: () => import(/* webpackChunkName: "about" */ '../views/ErrorPage/ErrorPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes:routes,
  mode: 'history',
})

// 路由守卫
router.beforeEach((to, from, next) => {
  store.dispatch('showLoading'); // 显示 Loading
  // store.commit("loginModel/login",true)
  const isLogin = store.getters['loginModel/getLoginState'] // 是否登录
  const userInfo = store.getters['loginModel/getUserInfo'] // 获取用户信息
  const role = store.getters['loginModel/getRole'] // 获取用户角色
  // console.log(isLogin,userInfo,role)
  if (isLogin) { // 如果已经登录
    if(!role || !userInfo){ // 没有用户权限
      ElMessage.error('登录已过期，请重新登录')
      store.commit("loginModel/loginOut")
    }
    // 判断权限是否相符
    if(to.meta.role && (to.meta.role!==role)){ // 如果访问的带权限的页面，而且访问的页面不属于当前页面权限
      ElMessage.error('您无权访问当前页面')
      store.commit("loginModel/loginOut")
      return
      // return next({path:'/'})
    }
    // 判断是否是登录页面，如果进入的是登录页面，则进入到首页
    if (to.name === 'login') {
      // next({path:'/'}) // 如果已经登录了，跳转到登录页的时候，登录到首页
      if(role==="admin"){
        next({path:"/admin",replace:true})
      }else if(role==="special"){
        next({path:"/special",replace:true})
      }else if(role==="students"){
        next({path:"/student",replace:true})
      }
    } else {
      next()
    }
  } else { // 如果没登录，跳转到登录页面，登录页不显示进度条
    if (to.name === 'login' ||to.name === 'register' ) {
      next()
    } else {
      next({path: "/login"})
    }
  }
})
// 路由进入
router.afterEach(()=>{
  store.dispatch('hideLoading'); // 隐藏 Loading
})
export default router
